const schema = () => ({
  type: "object",
  required: [],
  properties: {
    unit_ids: {
      type: "array",
      title: "کلینیک ها",
      items: {
        type: "string",
      },
    },
    lab_ids: {
      type: "array",
      title: "لابراتوار ها",
      items: {
        type: "string",
      },
    },
  },
});

export default schema;
